export default __webpack_public_path__ + "static/media/barbera-logo.191b64f1.svg";